import React, { useId, useRef } from 'react'

// components
import Breadcrumb from '../../components/Breadcrumb/Breadcrumb'
import ActivePasses from './components/ActivePasses/ActivePasses'
import PastPasses from './components/PastPasses/PastPasses'
import MyPassesPageHead from './components/MyPassesPageHead/MyPassesPageHead'

// types
import { MyPassesPageQuery, PageProps } from '../../types/types'

// hooks
import useMessages from '../../hooks/useMessages'

// styles
import * as SC from './MyPassesPageStyles'

// utils
import createPageContainer from '../../utils/createPageContainer'

type RouteProps = {}
type MyPassesPageData = {}

type MyPassesPageProps = PageProps<MyPassesPageData, MyPassesPageQuery, RouteProps>

const MyPassesPage = (props: MyPassesPageProps) => {
	const { query, setQuery } = props
	const { messages } = useMessages()
	const activePassesHeadingId = useId()
	const pastPassesHeadingId = useId()
	const activePassesContainerRef = useRef<HTMLElement>(null)
	const pastPassesContainerRef = useRef<HTMLElement>(null)

	const breadcrumbItems = [{ link: '', name: messages['Your Passes'] }]

	return (
		<>
			<MyPassesPageHead />
			<SC.PageContainer>
				<Breadcrumb breadcrumbItems={breadcrumbItems} hasSalonsBreadcrumb />
				<SC.MainTitle>{messages['Your Passes']}</SC.MainTitle>
				<SC.MainContent>
					<SC.PassesSection ref={activePassesContainerRef} tabIndex={-1} aria-labelledby={activePassesHeadingId}>
						<SC.SubTitle id={activePassesHeadingId}>{messages.Active}</SC.SubTitle>
						<ActivePasses query={query} setQuery={setQuery} activePassesContainerRef={activePassesContainerRef} />
					</SC.PassesSection>
					<SC.PassesSection ref={pastPassesContainerRef} tabIndex={-1} aria-labelledby={pastPassesHeadingId}>
						<SC.SubTitle id={pastPassesHeadingId}>{messages.Past}</SC.SubTitle>
						<PastPasses query={query} setQuery={setQuery} pastPassesContainerRef={pastPassesContainerRef} />
					</SC.PassesSection>
				</SC.MainContent>
			</SC.PageContainer>
		</>
	)
}

const MyPassesPageContainer = createPageContainer<MyPassesPageData, MyPassesPageQuery, RouteProps>({
	identifier: 'MyPassesPage',
	PageComponent: MyPassesPage,
	initDefaultData: async () => {
		return {}
	}
})

export default MyPassesPageContainer
